module.exports = __webpack_public_path__ + "static/Gotham-MediumItalic-3d3facbbeb313a5796f2b7b300d0883a.ttf";